/*
 * PendingList Messages
 *
 * This contains all the text for the PendingList component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.components.PendingList.header',
    defaultMessage: 'Drafts and Scheduled Posts',
  },
  headerPortfolio: {
    id: 'app.components.PendingList.headerPortfolio',
    defaultMessage: 'Draft Posts',
  },
  noTitle: {
    id: 'app.components.PendingList.noTitle',
    defaultMessage: 'No Title',
  },
  groupMessage: {
    id: 'app.components.PendingList.groupMessage',
    defaultMessage: 'Group Messages',
  },
  personalMessage: {
    id: 'app.components.PendingList.personalMessage',
    defaultMessage: 'Personal Message',
  },
  draft: {
    id: 'app.components.SetView.draft',
    defaultMessage: 'Draft',
  },
});
